export default defineNuxtPlugin(() => {
  if (!['production', 'staging'].includes(process.env.NODE_ENV)) {
    return;
  }

  function loadScript() {
    window.removeEventListener('touchstart', loadScript);
    window.removeEventListener('mousemove', loadScript);
    window.removeEventListener('scroll', loadScript);

    (function (w, d) {
      if (!w.rdt) {
        const p = (w.rdt = function () {
          p.sendEvent
            ? p.sendEvent.apply(p, arguments)
            : p.callQueue.push(arguments);
        });
        p.callQueue = [];
        const t = d.createElement('script');
        t.src = 'https://www.redditstatic.com/ads/pixel.js';
        t.async = !0;
        const s = d.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(t, s);
      }
    })(window, document);

    create();
  }

  function create() {
    window.rdt('init', 't2_sprk0y2d', {
      optOut: false,
      useDecimalCurrencyValues: true,
    });
    window.rdt('track', 'PageVisit');

    const router = useRouter();

    router.afterEach(() => {
      window.rdt('track', 'PageVisit');
    });
  }

  window.addEventListener('touchstart', loadScript);
  window.addEventListener('mousemove', loadScript);
  window.addEventListener('scroll', loadScript);
});
